export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tool.file.metadata.vue?vue&type=template&id=376c3b21&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/tool/file/tool.file.metadata.vue?vue&type=template&id=376c3b21&scoped=true&
// module id = 757
// module chunks = 3